//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TestingApiMethodComponentString",

  data: function () {
    return {
      options: [],
    }
  },

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    value: {},
  },

  components: {

  },

  methods: {
    change: function ({ target }) {
      const value = target?.value || ""
      this.$emit('change', {
        value: value,
        name: this.item?.key
      });
    }
  }
}
